namespace SP {
    export interface DropPointInfo {
        id: string;
        name: string;
        distance: number;
        carrierCode: string;
        address: DropPointAddressInfo;
        coordinates: DropPointCoordinateInfo;
    }

    export interface DropPointAddressInfo {
        addressType: number;
        city: string;
        country: string;
        street1: string;
        zipcode: string;
    }

    export interface DropPointCoordinateInfo {
        latitude: number;
        longitude: number;
    }
}